import { z } from "zod";
// XI canonical business domains. Single source of truth — must mirror
// XTS/src/config/domains.ts. Companies are modelled across exactly these 6
// domains regardless of industry; PlayStudio scopes Inbox + Plays + memberships
// to a domain and surfaces a domain switcher in the topbar.
export const XI_DOMAINS = [
    "people",
    "process",
    "market_and_brand",
    "tech",
    "finance",
    "offer",
];
export const DomainSchema = z.enum(XI_DOMAINS);
export const DOMAIN_LABELS = {
    people: "People & Capability",
    process: "Process & Operations",
    market_and_brand: "Market & Brand",
    tech: "Technology",
    finance: "Finance",
    offer: "Offer",
};
